<template>
  <div class="hello">
    <!-- <Navbar :isFirst="index"></Navbar> -->
    <div class="homePage">
      <First @contactBug="toBottom()"></First>
      <Second></Second>
      <Three></Three>
      <newFour></newFour>
      <Five @topBack="topBack()"></Five>
    </div>
    <!-- 手机 -->
    <div class="photos">
      <div class="photo one">
        <a  class="opacity" @click="backbottom()"></a>
      </div>
      <div class="photo two">
        <a  class="opacity" @click="phsoft()"></a>
      </div>
      <div class="photo three"></div>
      <div class="photo four">
        <a  class="opacity" @click="phsoft1()"></a>
      </div>
      <div class="photo five" >
        <div class="phone-up">
              <div class="left">
                  <p>联系我们</p>
                  <p>CONTACT US</p>
                  <div class="hand"><img src="../assets/fivep/05_03.png" alt=""></div>
              </div>
              <div class="right">
                <ul class="navs">
                        <li>业务洽谈：<a class="tel1">{{telNum}}</a><a class="name1">({{telName}})</a></li>
                        <li>投诉建议：<a>18027103455</a>(彭生)</li>
                        <li>售后服务：<a>400-900-5939</a></li>
                </ul>
              <div class="longline"></div>
                <div class="bot">
                      <p>联系邮箱：marketing@weimaqi.com</p>
                      <p>公司地址：广州市番禺区南村镇鸿创直街19号五楼(番禺工业经济总部园区禹能集团总部大楼五楼)</p>
              </div>
              <ul class="icons">
                  <li><img src="../assets/fivep/wechat.svg" alt=""></li>
                  <li><img src="../assets/fivep/QQ.svg" alt=""></li>
                  <li>
                    <div class="liphone">
                      <div class="liph">商务合作电话</div>
                      <span class="liph1">400-900-5939</span>
                    </div>
                    <img src="../assets/fivep/phone.svg" alt="">
                  </li>
                  <li>
                    <div class="liemail">
                      <div class="liph">商务合作邮箱</div>
                      <span class="liph1">marketing@weimaqi.com</span>
                    </div>
                    <a href="mailto:marketing@weimaqi.com"><img src="../assets/fivep/email.svg" alt=""></a>
                  </li>
                  <li>
                    <div class="liewm">
                      <div class="lione">微信公众号</div>
                      <div class="litwo">请扫描二维码关注</div>
                      <div class="img"> <img class="wm" src="./hardProduct/images/erweima.jpg" alt=""></div>
                    </div>
                    <img src="../assets/fivep/QRcode.svg" alt="" >
                  </li>          
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/swiper-4.2.0.min.css';
import Navbar from './Navbar'
import First from './First'
import Second from './Second'
import Three from './Three'
import newFour from './newFour'
import Five from './Five'

export default {
  name: 'home',
  components: { First,Second,Three,newFour,Five,Navbar},
  data(){
    return{
      index: '01',
      current:'d1',
      cur:'',
      icons:[
        {img:require('../assets/fivep/wechat.svg')},
        {img:require('../assets/fivep/QQ.svg')},
        {img:require('../assets/fivep/phone.svg')},
        {img:require('../assets/fivep/email.svg')},
        {img:require('../assets/fivep/QRcode.svg')},
      ],
      img:require('../assets/fivep/hand.png'),
      telNum: '',
      telName: '',
      nums: [
        {tel:'18773232030',name:'王生'},
        {tel:'18929539209',name:'李生'},
        {tel:'13539860650',name:'湛生'},
        {tel:'15659363555',name:'杨生'},
        {tel:'13822274256',name:'付生'}
        ],
      oldTime: (new Date("2018/04/23 00:00:00")).getTime(),
      timestamp: new Date().getTime(),
    }
  },
  mounted(){
    this.$store.state.homeDot = true
    this.$store.state.hardDot = false
    this.$store.state.softDot = false
    this.$store.state.coopDot = false
    this.$store.state.aboutDot = false
    this.$store.state.d4 = 'sd4ds2a3d4';
    var d = this.timestamp - this.oldTime;
    var week = 7*24*60*60*1000;
    var ns = Math.floor(d/week);
    var n = ns - (Math.floor(ns/5)*5);
    this.telNum = `${this.nums[n].tel}`;
    this.telName = `${this.nums[n].name}`;
  },
  methods:{
    backbottom(){
      document.body.scrollTop = document.body.scrollHeight - document.body.clientHeight;
      document.documentElement.scrollTop = document.body.scrollHeight - document.body.clientHeight;
    },
    phsoft(){
       this.$router.push({path:'/software'});
       document.body.scrollTop = 0;
       document.documentElement.scrollTop = 0;
    },
    phsoft1(){
      this.$router.push({path:'/software'});
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    // 回到顶部
    topBack () {
      document.body.scrollTop = 0;          //仅仅设置 document.body 可能会有兼容性问题
      document.documentElement.scrollTop = 0
    },
    // 回到底部
    toBottom () {
      document.body.scrollTop = document.body.scrollHeight - document.body.clientHeight;
      document.documentElement.scrollTop = document.body.scrollHeight - document.body.clientHeight;
    }
  },
}
  
</script>

<style scoped>
.homePage { 
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  }
.photos{
  display: none;
}
.sider{
height: 500px;
position: fixed;
right: 30px;
/* bottom: 7%; */
bottom: 44px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
z-index: 99;
}
.dots span{
  width: 10px;
    height: 10px;
    margin-bottom: 20px;
    display: block;
    border-radius: 50%;
    cursor: pointer;
    margin: 15px 0;
    background: #333;
    opacity: 1;
}
.dots span.on{
  background: #198bfe;
}
.longline{
width: 1px;
height: 175px;
background-color: #666;
margin-top: 30px;
}
.num{
    font-size: 14px;
    color: #333;
    margin: 30px 0;
}
.direct{
  display: flex;
    flex-direction: column;
}

.direct .up ,.direct .down{
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  cursor: pointer;
}
.direct .up{
background: url(../assets/up-black.svg) no-repeat;
width: 40px;
  height: 40px;
   margin-bottom: 11px;
   cursor: pointer;
}
.direct .down{
  width: 40px;
  height: 40px;
  background: url(../assets/down-black.svg) no-repeat;
}
.direct .up:hover{
  width: 40px;
  height: 40px;
  background: url(../assets/up-blue.svg) no-repeat;
}
.direct .down:hover{
  width: 40px;
  height: 40px;
  background: url(../assets/down-blue.svg) no-repeat;
}
.sider.d1 .num,.sider.d5 .num{
  color: #fff;
}
.sider.d1 .longline,.sider.d5 .longline{
  background: #fff;
}
.sider.d1 .direct .up,.sider.d5 .direct .up{
  background: url(../assets/up-white.svg) no-repeat;
}
.sider.d1 .direct .down,.sider.d5 .direct .down{
  background: url(../assets/down-white.svg) no-repeat;
}
.sider.d1 .direct .up:hover,.sider.d5 .direct .up:hover{
  background: url(../assets/up-blue.svg) no-repeat;
}
.sider.d1 .direct .down:hover,.sider.d5 .direct .down:hover{
  background: url(../assets/down-blue.svg) no-repeat;
}
.swiper-wrapper>.swiper-slide{
  overflow: hidden;
}


.header.d1 .fa.fa-bars:hover,.header.d5 .fa.fa-bars:hover{
  color:#198bfe;
}
.header.d1 .section_header .logo, .header.d5 .section_header .logo{
  background: url(../assets/logo-white.png);
    background-size: 100% 100%;
    width: 119px;
    height: 24px;
}

.sider.d1 .dots span,.sider.d5 .dots span{
  background: #fff;
    opacity: 1;
}
.sider.d1 .dots span.on,.sider.d5 .dots span.on{
  background: #198bfe;
  opacity: 1;
}



/* First css */
.sectionFirst{
    width: 100%;
    height: 100%;
    color: #fff;
    /* background: url(../assets/firstp/bg.jpg) no-repeat; */
     background-size: cover;
         background-position: center;
 }
 
.sectionFirst .pd{
    position: absolute;
    width: 100%;
    top: 23%;
}
@media screen and (min-width:1680px){
  .sectionFirst .pd{
    top: 15%;
  }
  .sectionFirst .content{
        bottom: 9%;
    }
}
.sectionFirst .pd .image{
    width: 30%;
    margin-left: auto;
    margin-right: auto;
}
.sectionFirst .pd .image img{
    width: 100%;
}
.sectionFirst .index_hd{
    position: absolute;
    width: 100%;
    color: #fff;
    text-align: center;
    z-index: 10;
    top: 25%;
}
.sectionFirst .index_hd h2{
	font-family: 微软雅黑;
	font-size: 50px;
	line-height: 50px;
	letter-spacing: 5px;
	color: #ffffff;
}
.sectionFirst .content {
    position: absolute;
    z-index: 10;
    bottom: 12%;
    text-align: center;
    width: 100%;
}
.sectionFirst .content p{
    font-size: 18px;
	font-weight: normal;
	line-height: 18px;
	letter-spacing: 0px;
	color: #666666;
    font-family: 微软雅黑;
}
.sectionFirst .bug a{
    color: #fff;
}
.sectionFirst .bug{
     margin: 42px auto 0;
    text-align: center;
     color: #fff;
    width: 200px;
    height: 60px;
    line-height: 60px;
    /* border: 1px solid #2f9fff; */
    border-radius: 32px;
    font-size: 18px;
    font-family: 微软雅黑;
    cursor: pointer;
    background: -webkit-linear-gradient(left, #2f9fff , #1276ff); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, #2f9fff, #1276ff); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, #2f9fff, #1276ff); /* Firefox 3.6 - 15 */
  filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#2f9fff,endcolorstr=#1276ff,gradientType=1);
  background: linear-gradient(to right,#2f9fff, #1276ff); 
 }
 :root .bug{filter:none;}

@media screen and (max-height: 800px){
   .sectionFirst .index_hd{
        transform: scale(0.8);
        top:13%;
    }
   .sectionFirst .pd .image{
        transform: scale(0.8);
    }
    .sectionFirst .pd{
      top:15%;
    }
   .sectionFirst .content{
        bottom: 10%;
    }
}
.liphone{
position: absolute;
  top: -120px;
  left: -62px;
width: 160px;
text-align: center;
background: #fff;
color: #333;
padding: 20px 0px;
display: none;
}
.liemail{
position: absolute;
    top: -120px;
    left: -80px;
width: 210px;
text-align: center;
background: #fff;
color: #333;
padding: 20px 0px;
display: none;
}
 .liph{
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}
 .liph1{
  color: #198bfe;
    font-weight: bold;
  font-size: 16px;
  display: block;
}
.liphone::after,.liemail::after{
content: '';
position: absolute;
  top: 100px;
  left: 73px;
width: 0;
height: 0;
border-left: 5px solid transparent;
border-top: 5px solid #fff;
border-right: 5px solid transparent;
}
.liemail::after{
  left: 90px;
}
.sectionFive .icons li:nth-child(3):hover .liphone{
display: block;
}
.sectionFive .icons li:nth-child(4):hover .liemail{
display: block;
}
.liewm{
  width: 160px;
  position: absolute;
     top: -232px;
    left: -62px;
  background: #fff;
  display: none;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  text-align: center;
  padding: 26px 0px;
  box-sizing: border-box;
  display: none;
}
.liewm .lione{
  font-size: 16px;
  font-weight: bold;
  color: #333;
  font-family: 微软雅黑;
  line-height: 20px;

}
.liewm .litwo{
  font-size: 14px;
  color: #999;
  font-family: 微软雅黑;
  line-height: 30px;
}
.liewm .img{
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.liewm::after{
  content: '';
position: absolute;
    top: 212px;
    left: 73px;
width: 0;
height: 0;
border-left: 5px solid transparent;
border-top: 5px solid #fff;
border-right: 5px solid transparent;
}
.sectionFive .icons li .liewm .wm{
  width: 100%;
  height: 100%;
}
.sectionFive .icons li:nth-child(5):hover .liewm{
display: block;
}
@media screen and (max-width:1370px) {
  .sectionFive .main .image{
  width: 42%;
  margin-right: 83px;
}
}


/* 手机 */
@media screen and (max-width:768px){
  body{
    width: 100%;
    height: 100%;
    /* background: #000; */
  }
  .sider,.homePage{
    display: none;
  }
  .swiper-pagination{
    display: none;
  }
  .hello{
    width: 100%;
    height: 100%;
  }
  .photos{
  display: block;
  width: 100%;
  height: 100%
  }
  .photos .photo.one{
    width: 100%;
    height: 100%;
    background: url('../assets/phone/01.jpg') no-repeat;
    background-size: 100% 100%;
    margin-top: 48px;
    display: flex;
    justify-content: center;
  }
  .photo.one .opacity{
    display: block;
      width: 50%;
    height: 20%;
    /* background: #198bfe; */
    position: relative;
    bottom: -65%;
    left: 0px;
    z-index: 1;
  }
 
  .photos .photo.two{
    width: 100%;
    height: 100%;
    background: url('../assets/phone/02.jpg') no-repeat;
    background-size: 100%;
    background-position: center;
    display: flex;
    justify-content: center;
  }
    .photo.two .opacity{
    display: block;
      width: 50%;
    height: 20%;
    /* background: #198bfe; */
    position: relative;
    bottom: -79%;
    left: 0px;
    z-index: 1;
  }
  .photos .photo.three{
    width: 100%;
    height: 100%;
    background: url('../assets/phone/03.jpg') no-repeat;
    background-size: 100%;
    background-position: center;
  }
  .photos .photo.four{
    width: 100%;
    height: 100%;
    background: url('../assets/phone/04.jpg') no-repeat;
    background-size: 100%;
    background-position: center;
    display: flex;
    justify-content: center;
  }
  .photo.four .opacity{
    display: block;
      width: 50%;
    height: 20%;
    /* background: #198bfe; */
    position: relative;
   bottom: -79%;
    left: 0px;
    z-index: 1;
  }
 .sectionFive .mains{
      display: none;
    }
    .sectionFive{
      width: 100%;
      /* height: 100%; */
      height: calc(100% - 48px);
      background: url('../assets/phone/05.jpg') no-repeat;
      background-size: 100% 100%;
      margin-top: 48px;
    }
.sectionFirst .index_hd,.sectionFirst .pd,.sectionFirst .content{
      display: none;
    }
    .sectionFirst{
     width: 100%;
      height: calc(100% - 48px);
      background: url('../assets/phone/01.jpg') no-repeat;
      background-size: 100% 100%;
      margin-top: 48px;
    }

  .photo.five{
    width: 100%;
    /* height: 100%; */
    background: #000;
      overflow-y: auto;
    }
  .phone-up{
    width: 100%;
    height: 100%;
    padding: 0px 15px;
    box-sizing: border-box;
        display: flex;
    flex-direction: column;
    align-items: center;
}
.phone-up .left{
    margin-top: 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.phone-up .right{
  width: 85%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 40px;
}
.phone-up a.tel1{
  font-size: 18px;
  color: #fff;
}
.longline{
    width: 100%;
    height: 1px;
    background: #666;
    margin: 3% 0px;
}
.left p:nth-child(1){
    font-size: 18px;
    color: #fff;
    margin-top: 25px;
}
.left p:nth-child(2){
    font-size: 18px;
    color: #fff;
     margin-top: 11px;
}
.left .hand{
  width: 88%;
   margin-top: 25px;
}
.left .hand img{
  width: 100%;
}
.bot p{
    font-size: 12px;
    color: #999;
    line-height: 26px;
}
.navs li a{
    color: #fff;
    font-size: 18px;
    font-family: number-webfont;
}
.navs{
    margin-top: 7%;
}
.navs li,.navs li a.name1{
  color: #999;
  font-size: 12px;
    line-height: 26px;
}
.icons{
      display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 20px 0px;
}

.icons>li>img{
  height: 30px;
  width: 30px;
  color: #fff;
}
.icons>li a{
  display: block;
  height: 30px;
  width: 30px;
  color: #fff;
}
.liewm{
  width: 145px;
}
.liewm .img img{
  width: 100%;
}
.icons li{
  position: relative;
}
.icons li:nth-child(3):hover .liphone{
display: block;
}
 .icons li:nth-child(4):hover .liemail{
display: block;
}
.icons li:nth-child(5):hover .liewm{
display: block;
}

}
</style>



// WEBPACK FOOTER //
// src/components/home.vue